module.exports = __webpack_public_path__ + "static/img/aliados_ijalti.825091e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alliance/aliados_ijalti.png
// module id = BeC9
// module chunks = 47